import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAppBoot } from "./app-boot-provider";
import { authSession } from "../lib/auth-session";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { booting } = useAppBoot();
  const isAuthenticated = authSession.useIsAuthenticated();

  if (booting) {
    return <div className="p-8 text-center text-muted">Načítání…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
